import axios from 'axios';

const instance = axios.create({
    baseURL:"https://mina--mainnet--indexer.datahub.figment.io/apikey/b7a89ff599271e860f64120eded1f32b",
});
 export default instance;
